<template>
  <div class="payment modal-wrapper">
    <div
      class="modal-wrapper__mobile"
      :class="{ 'rbxpier-search-color': $store.state.toggleSite === 'rbxpier' }"
      v-show="isOpenMobileFilter"
    >
      <h1>CHOOSE THE PAYMENT</h1>
      <div class="modal-wrapper__mobile-content">
        <ul>
          <li @click="changePayment" :class="{ 'checked-filter': paymentSystem === 'CardLink' }">CardLink</li>
          <li @click="changePayment" :class="{ 'checked-filter': paymentSystem === 'OverPay' }">OverPay</li>
        </ul>
      </div>
      <div class="modal-wrapper__mobile-button">
        <button @click="isOpenMobileFilter = false">Применить</button>
      </div>
    </div>
    <div
      class="modal-wrapper__block"
      v-if="!isOpenMobileFilter"
      :class="{ 'st-2': stage === 2 && !errors.status, 'rbxpier-search-color': $store.state.toggleSite === 'rbxpier' }"
    >
      <div
        class="modal-wrapper__block-close"
        @click="$store.state.isOpenPaymentSearch = false"
        :class="{ 'rbxpier-color-arrow': $store.state.toggleSite === 'rbxpier' && isMobileVersion }"
      >
        <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12.9436 10.1263L4.03296 1.19612C3.64183 0.805056 3.11136 0.585356 2.55823 0.585356C2.0051 0.585356 1.47463 0.805056 1.08351 1.19612C0.692386 1.58719 0.472656 2.11758 0.472656 2.67063C0.472656 3.22368 0.692386 3.75408 1.08351 4.14515L10.0149 13.0545L1.08351 21.9639C0.692386 22.355 0.472656 22.8854 0.472656 23.4384C0.472656 23.9915 0.692386 24.5219 1.08351 24.913C1.47463 25.304 2.0051 25.5237 2.55823 25.5237C3.11136 25.5237 3.64183 25.304 4.03296 24.913L12.9436 15.9828L21.8543 24.913C22.0474 25.1076 22.2771 25.2621 22.5302 25.3675C22.7833 25.473 23.0548 25.5273 23.329 25.5273C23.6032 25.5273 23.8747 25.473 24.1278 25.3675C24.3809 25.2621 24.6106 25.1076 24.8037 24.913C24.9984 24.7199 25.1529 24.4902 25.2584 24.2371C25.3638 23.9841 25.4181 23.7126 25.4181 23.4384C25.4181 23.1643 25.3638 22.8928 25.2584 22.6398C25.1529 22.3867 24.9984 22.157 24.8037 21.9639L15.8723 13.0545L24.8037 4.14515C24.9984 3.95208 25.1529 3.72239 25.2584 3.46932C25.3638 3.21624 25.4181 2.94479 25.4181 2.67063C25.4181 2.39647 25.3638 2.12503 25.2584 1.87195C25.1529 1.61888 24.9984 1.38918 24.8037 1.19612C24.6106 1.00147 24.3809 0.846964 24.1278 0.741529C23.8747 0.636093 23.6032 0.581812 23.329 0.581812C23.0548 0.581812 22.7833 0.636093 22.5302 0.741529C22.2771 0.846964 22.0474 1.00147 21.8543 1.19612L12.9436 10.1263Z"
            fill="#2F2F2F"
          />
        </svg>
      </div>
      <div
        class="modal-wrapper__block-arrow"
        :class="{ 'rbxpier-color-arrow': $store.state.toggleSite === 'rbxpier' && isMobileVersion }"
        v-if="stage === 2 || errors.status"
        @click="
          stage = 1;
          errors.status = false;
        "
      >
        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0.156344 13.2928C0.255541 13.5483 0.404281 13.7818 0.594028 13.9797L11.015 24.3878C11.2094 24.5819 11.4401 24.7359 11.694 24.8409C11.9479 24.9459 12.22 25 12.4948 25C13.0498 25 13.5821 24.7798 13.9746 24.3878C14.1689 24.1937 14.3231 23.9633 14.4282 23.7097C14.5334 23.4561 14.5875 23.1843 14.5875 22.9099C14.5875 22.3555 14.367 21.8239 13.9746 21.4319L7.09673 14.5834L22.9158 14.5834C23.4686 14.5834 23.9987 14.3641 24.3896 13.9737C24.7804 13.5833 25 13.0539 25 12.5018C25 11.9497 24.7804 11.4202 24.3896 11.0298C23.9987 10.6395 23.4686 10.4202 22.9158 10.4202L7.09673 10.4202L13.9746 3.57163C14.1699 3.37812 14.325 3.14789 14.4308 2.89423C14.5366 2.64056 14.5911 2.36848 14.5911 2.09369C14.5911 1.81889 14.5366 1.54681 14.4308 1.29314C14.325 1.03948 14.1699 0.809252 13.9746 0.615739C13.7808 0.420632 13.5503 0.265768 13.2963 0.160087C13.0424 0.0544057 12.7699 -2.74551e-06 12.4948 -2.72146e-06C12.2197 -2.6974e-06 11.9472 0.0544058 11.6933 0.160087C11.4393 0.265768 11.2088 0.420632 11.015 0.615739L0.594027 11.0238C0.40428 11.2218 0.25554 11.4552 0.156344 11.7108C-0.0521132 12.2176 -0.0521132 12.786 0.156344 13.2928Z"
            fill="#2F2F2F"
          />
        </svg>
      </div>
      <div class="modal-wrapper__block-content" v-if="stage === 1 && isLoaded">
        <h1>PAYMENT SEARCH</h1>
        <div class="modal-wrapper__block-content__form">
          <div class="modal-wrapper__block-content__form-filter" @click="isOpenMobileFilter = true">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M13.4541 0.208302H2.54581C1.92587 0.208302 1.33132 0.454573 0.892951 0.89294C0.454585 1.33131 0.208313 1.92586 0.208313 2.5458V3.45743C0.208201 3.77918 0.274516 4.09749 0.403105 4.39243V4.43918C0.513185 4.68927 0.669106 4.91654 0.862813 5.10926L5.66248 9.87776V15.0125C5.66222 15.1449 5.6957 15.2752 5.75978 15.3911C5.82385 15.5069 5.9164 15.6046 6.02869 15.6748C6.15269 15.7516 6.29577 15.7921 6.44165 15.7916C6.56362 15.7909 6.68372 15.7615 6.79227 15.7059L9.90894 14.1476C10.0374 14.0828 10.1455 13.9838 10.2211 13.8614C10.2968 13.739 10.337 13.598 10.3375 13.4541V9.87776L15.106 5.10926C15.2997 4.91654 15.4556 4.68927 15.5657 4.43918V4.39243C15.705 4.0998 15.782 3.78139 15.7916 3.45743V2.5458C15.7916 1.92586 15.5454 1.33131 15.107 0.89294C14.6686 0.454573 14.0741 0.208302 13.4541 0.208302ZM9.00511 9.00509C8.93289 9.0779 8.87576 9.16424 8.83698 9.25918C8.79821 9.35411 8.77855 9.45576 8.77915 9.5583V12.9711L7.22081 13.7502V9.5583C7.22141 9.45576 7.20175 9.35411 7.16298 9.25918C7.1242 9.16424 7.06707 9.0779 6.99486 9.00509L2.86527 4.8833H13.1347L9.00511 9.00509ZM14.2333 3.32497H1.76665V2.5458C1.76665 2.33915 1.84874 2.14097 1.99486 1.99485C2.14098 1.84873 2.33917 1.76663 2.54581 1.76663H13.4541C13.6608 1.76663 13.859 1.84873 14.0051 1.99485C14.1512 2.14097 14.2333 2.33915 14.2333 2.5458V3.32497Z"
                fill="#069C38"
              />
            </svg>
          </div>
          <div class="dropdown">
            <div class="dropdown-checked" @click="isOpenDropDown = true">
              <p :class="{ 'border-r': this.isOpenDropDown }">
                {{ paymentSystem }}
              </p>
            </div>
            <div class="dropdown-menu" v-show="this.isOpenDropDown">
              <ul>
                <li @click="changePayment" v-if="this.paymentSystem !== 'CardLink'">CardLink</li>
                <li @click="changePayment" v-if="this.paymentSystem !== 'OverPay'">OverPay</li>
              </ul>
            </div>
          </div>
          <div class="payment-form">
            <div class="modal-wrapper__block-content__form-label">
              <div
                class="modal-wrapper__block-content__form-label__checked"
                @click="isOpenPaymentType = !isOpenPaymentType"
              >
                <p>{{ paymentType }}</p>
                <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M5.99971 4.70993L2.4597 1.16993C2.27234 0.983683 2.01889 0.879142 1.7547 0.879142C1.49052 0.879142 1.23707 0.983683 1.0497 1.16993C0.955976 1.2629 0.881581 1.3735 0.830813 1.49536C0.780044 1.61722 0.753906 1.74792 0.753906 1.87993C0.753906 2.01195 0.780044 2.14265 0.830813 2.26451C0.881581 2.38637 0.955976 2.49697 1.0497 2.58993L5.28971 6.82993C5.38267 6.92366 5.49327 6.99806 5.61513 7.04883C5.73699 7.09959 5.86769 7.12573 5.99971 7.12573C6.13172 7.12573 6.26242 7.09959 6.38428 7.04883C6.50614 6.99806 6.61674 6.92366 6.70971 6.82993L10.9997 2.58993C11.0924 2.49649 11.1657 2.38568 11.2155 2.26384C11.2652 2.142 11.2905 2.01154 11.2897 1.87993C11.2905 1.74833 11.2652 1.61787 11.2155 1.49603C11.1657 1.37419 11.0924 1.26337 10.9997 1.16993C10.8123 0.983683 10.5589 0.879141 10.2947 0.879141C10.0305 0.879141 9.77707 0.983683 9.58971 1.16993L5.99971 4.70993Z"
                    fill="#2F2F2F"
                  />
                </svg>
              </div>
              <div class="modal-wrapper__block-content__form-label__dropdown" v-show="isOpenPaymentType">
                <p @click="selectPaymentType" v-if="paymentType !== 'Topup id'">Topup id</p>
                <p @click="selectPaymentType" v-if="paymentType !== 'Invoice id'">Invoice id</p>
              </div>
            </div>
            <div class="modal-wrapper__block-content__form-input">
              <div class="modal-wrapper__block-content__form-input__img">
                <svg width="45" height="42" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M13.5972 11.6354H15.5327C15.6379 11.636 15.7423 11.616 15.8397 11.5767C15.9371 11.5374 16.0258 11.4795 16.1005 11.4062L19.7634 7.78775C19.8384 7.7143 19.8979 7.62692 19.9385 7.53064C19.9791 7.43437 20 7.3311 20 7.2268C20 7.12251 19.9791 7.01924 19.9385 6.92296C19.8979 6.82669 19.8384 6.7393 19.7634 6.66586L17.828 4.7539C17.7536 4.67985 17.6652 4.62107 17.5677 4.58096C17.4703 4.54085 17.3657 4.5202 17.2602 4.5202C17.1546 4.5202 17.05 4.54085 16.9526 4.58096C16.8551 4.62107 16.7667 4.67985 16.6923 4.7539L13.0294 8.3724C12.8832 8.5238 12.8004 8.72416 12.7975 8.93334V10.8453C12.7975 11.0548 12.8817 11.2558 13.0317 11.404C13.1817 11.5521 13.3851 11.6354 13.5972 11.6354ZM14.397 9.26517L17.2602 6.43674L18.0599 7.2268L15.1968 10.0552H14.397V9.26517ZM19.1956 10.8453C18.9835 10.8453 18.7801 10.9285 18.6301 11.0767C18.4801 11.2249 18.3958 11.4258 18.3958 11.6354V17.1658C18.3958 17.3753 18.3116 17.5763 18.1616 17.7245C18.0116 17.8726 17.8082 17.9559 17.5961 17.9559H6.3993C6.18719 17.9559 5.98377 17.8726 5.83378 17.7245C5.6838 17.5763 5.59954 17.3753 5.59954 17.1658V9.57329L10.3022 14.2268C10.5254 14.4501 10.7912 14.6275 11.0843 14.7485C11.3775 14.8695 11.692 14.9319 12.0097 14.9319C12.3274 14.9319 12.6419 14.8695 12.935 14.7485C13.2281 14.6275 13.494 14.4501 13.7172 14.2268C13.8637 14.0791 13.9458 13.8805 13.9458 13.6737C13.9458 13.4669 13.8637 13.2684 13.7172 13.1207C13.6427 13.0454 13.5537 12.9856 13.4555 12.9448C13.3574 12.904 13.2519 12.883 13.1453 12.883C13.0388 12.883 12.9333 12.904 12.8351 12.9448C12.737 12.9856 12.648 13.0454 12.5735 13.1207C12.424 13.2654 12.223 13.3465 12.0137 13.3465C11.8043 13.3465 11.6033 13.2654 11.4538 13.1207L6.72721 8.4593H10.3981C10.6103 8.4593 10.8137 8.37607 10.9637 8.2279C11.1137 8.07973 11.1979 7.87878 11.1979 7.66924C11.1979 7.4597 11.1137 7.25875 10.9637 7.11058C10.8137 6.96241 10.6103 6.87917 10.3981 6.87917H6.3993C5.76297 6.87917 5.1527 7.12889 4.70274 7.57339C4.25278 8.01789 4 8.62075 4 9.24937V17.15C4 17.7786 4.25278 18.3815 4.70274 18.826C5.1527 19.2705 5.76297 19.5202 6.3993 19.5202H17.5961C18.2324 19.5202 18.8427 19.2705 19.2926 18.826C19.7426 18.3815 19.9954 17.7786 19.9954 17.15V11.6196C19.9954 11.41 19.9111 11.2091 19.7611 11.0609C19.6111 10.9127 19.4077 10.8295 19.1956 10.8295V10.8453Z"
                    fill="#2F2F2F"
                  />
                </svg>
              </div>
              <input
                type="text"
                :placeholder="paymentType === 'Invoice id' ? 'Enter Invoice ID' : 'Enter topup ID'"
                v-model="searchInput"
              />
            </div>
          </div>
        </div>
        <div class="modal-wrapper__block-content__button">
          <button @click="getInfo">search</button>
        </div>
      </div>
      <div class="error" v-if="errors.status">
        <p>{{ errors.errorMsg }}</p>
      </div>
      <div class="loader" v-if="!isLoaded">
        <Loader />
      </div>
      <div class="user__block" v-if="stage === 2 && isLoaded && !errors.status">
        <div class="user-name">
          <h1>PAYMENT SEARCH</h1>
        </div>
        <div class="status">
          <div class="status-wrapper">
            <div class="payment-subInfo">
              <p class="status-info">STATUS:</p>
              <div
                class="st"
                :class="{
                  ok: paymentStatus === 'SUCCESS' || Number(paymentStatus) === 1 || paymentStatus === 'successful',
                  cancel: paymentStatus === 'Refused' || Number(paymentStatus) === 9,
                  processing: paymentStatus === 'pending' || paymentStatus === 'incomplete',
                  new: paymentStatus === 'New' || paymentStatus === 'created',
                  error: paymentStatus === 'failed' || paymentStatus === 'FAIL' || paymentStatus === 'expired'
                }"
              >
                <p v-if="paymentStatus === 'SUCCESS' || Number(paymentStatus) === 1 || paymentStatus === 'successful'">
                  SUCCESS
                </p>
                <p v-if="paymentStatus === 'New' || Number(paymentStatus) === 0 || paymentStatus === 'created'">New</p>
                <p v-if="paymentStatus === 'Refused' || paymentStatus === 9">Cancel</p>
                <p v-if="paymentStatus === 'failed' || paymentStatus === 'FAIL'">Failed</p>
                <p v-if="paymentStatus === 'expired'">Expired</p>
                <p v-if="paymentStatus === 'pending' || paymentStatus === 'incomplete'">WAITING</p>
              </div>
            </div>
          </div>

          <div class="payment-subInfo">
            <p class="status-info">PAYMENT SYSTEM:</p>
            <div>
              {{ paymentSystem }}
            </div>
          </div>
        </div>
        <span v-if="paymentInvoice.message" class="error-message">Error message: "{{ paymentInvoice.message }}"</span>

        <div
          class="user__block-content__info"
          :class="{
            'style-info': paymentSystem === 'Payok' || paymentSystem === 'GameMoney'
          }"
        >
          <div class="user__block-content__info-item">
            <p class="user__block-content__info-item__title">Invoice ID</p>
            <p class="user__block-content__info-item__value">
              {{ paymentInvoice.invoiceId }}
            </p>
          </div>
          <div class="user__block-content__info-item">
            <p class="user__block-content__info-item__title">Topup ID</p>
            <p class="user__block-content__info-item__value">
              {{ paymentInvoice.topup_id }}
            </p>
          </div>
          <div class="user__block-content__info-item">
            <p class="user__block-content__info-item__title">Amount</p>
            <p class="user__block-content__info-item__value">
              {{ paymentInvoice.amount }} {{ paymentInvoice.currency }}
            </p>
          </div>
          <div class="user__block-content__info-item">
            <p class="user__block-content__info-item__title">CREDITED</p>
            <p class="user__block-content__info-item__value">
              {{ paymentInvoice.credited }} {{ paymentInvoice.currency }}
            </p>
          </div>
          <div class="user__block-content__info-item">
            <p class="user__block-content__info-item__title">COMMISSION</p>
            <p class="user__block-content__info-item__value">
              {{ paymentInvoice.commission }} {{ paymentInvoice.currency }}
            </p>
          </div>
          <div class="user__block-content__info-item">
            <p class="user__block-content__info-item__title">METHOD</p>
            <p class="user__block-content__info-item__value">
              {{ paymentInvoice.method }}
            </p>
          </div>
          <!--          <div
            class="user__block-content__info-item"
            v-if="paymentSystem === 'Enot' || paymentSystem === 'GameMoney'"
          >
            <p class="user__block-content__info-item__title">WALLET</p>
            <p
              class="user__block-content__info-item__value"
              v-if="paymentInvoice.payer_details && paymentSystem === 'Enot'"
            >
              {{ paymentInvoice.payer_details }}
            </p>
            <p
              class="user__block-content__info-item__value"
              v-if="
                (!paymentInvoice.payer_details && paymentSystem === 'Enot') ||
                (paymentSystem === 'GameMoney' && !paymentInvoice.wallet.length)
              "
            >
              Не указано
            </p>
            <p
              class="user__block-content__info-item__value"
              v-if="
                paymentSystem === 'GameMoney' && paymentInvoice.wallet.length
              "
            >
              {{ paymentInvoice.wallet }}
            </p>
          </div>-->
        </div>
        <div class="user__block-content__date">
          <div v-if="paymentInvoice.createdDate" class="user__block-content__date-info">
            <p class="">CREATED AT--</p>
            <p class="">
              {{ prettifyDate(paymentInvoice.createdDate) }}
            </p>
          </div>
          <div v-if="paymentInvoice.updatedDate" class="user__block-content__date-info">
            <p class="">UPDATED AT--</p>
            <p class="">
              {{ prettifyDate(paymentInvoice.updatedDate) }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "./paymentSearch.scss";

import Loader from "@/components/Loader/Loader";

export default {
  name: "PaymentSearch",
  components: {
    Loader
  },
  //60d19d04757ebb5bbe2d1641 enot
  data() {
    return {
      isMobileVersion: false,
      isOpenPaymentType: false,
      isOpenMobileFilter: false,
      isLoaded: true,
      stage: 1,
      searchInput: null,
      paymentSystem: "CardLink",
      paymentType: "Topup id",
      paymentStatus: null,
      isOpenDropDown: false,
      paymentInvoice: null,
      errors: {
        status: false,
        errorMsg: "Topup is not found."
      }
    };
  },
  methods: {
    selectPaymentType(event) {
      this.paymentType = event.target.textContent.trim();
      this.isOpenPaymentType = false;
    },
    changePayment(event) {
      this.paymentSystem = event.target.textContent.trim();
      if (!this.isOpenMobileFilter) this.isOpenDropDown = false;
    },
    checkResponse({ data, success, error }) {
      if (success) {
        this.isLoaded = true;
        if (this.paymentSystem === "CardLink") {
          if (data.data.length) {
            const invoice = data.data["0"];
            this.paymentStatus = data.data["0"].status;
            this.paymentInvoice = {
              invoiceId: invoice.bill_id,
              topup_id: data.topup_id,
              status: invoice.status,
              system: this.paymentSystem,
              method: (invoice.from_card && "CARD") || invoice.confirmation?.type,
              currency: invoice.currency_in,
              amount: invoice.amount,
              credited: invoice.account_amount === 0 ? invoice.amount - invoice.commission : invoice.account_amount,
              commission: invoice.commission,
              createdDate: invoice.created_at,
              updatedDate: "",
              message: invoice.error_message,
              receipt_url: invoice.receipt_url
            };
          } else {
            this.errors.status = true;
            // this.errors.errorMsg = "Ошибка платежа";
          }
        } else if (this.paymentSystem === "OverPay") {
          if (data.transactions.length) {
            const invoice = data.transactions["0"];

            this.paymentStatus = invoice.status;
            this.paymentInvoice = {
              invoiceId: invoice.uid,
              topup_id: invoice.tracking_id,
              status: invoice.status,
              system: this.paymentSystem,
              method: invoice.sbp ? "SBP" : "CARD",
              currency: invoice.currency,
              amount: invoice.amount / 100,
              credited:
                invoice.commission?.initial_amount / 100 || invoice.additional_data.adjustments?.initial_amount / 100,
              commission:
                invoice.commission?.surcharge_amount / 100 ||
                invoice.additional_data.adjustments?.adjustment_amount / 100,
              createdDate: invoice.created_at,
              updatedDate: invoice.updated_at,
              message: invoice.status === "successful" || invoice.status === "pending" ? "" : invoice.message,
              receipt_url: invoice.receipt_url
            };
          } else {
            this.errors.status = true;
            // this.errors.errorMsg = "Ошибка платежа";
          }
        }
      } else {
        this.errors.status = true;
        this.errors.errorMsg = error === "cardlink request failed" ? "Callback is not found." : data.error;
      }
      this.isLoaded = true;
      this.stage = 2;
    },
    async getInfo() {
      try {
        if (this.searchInput) {
          this.isLoaded = false;
          this.errors.status = false;

          let params = {};

          if (this.paymentType === "Topup id") {
            params = {
              CardLink: "topupId",
              OverPay: "topupId"
            };
          } else {
            params = {
              CardLink: "invoiceId",
              OverPay: "invoiceId"
            };
          }

          if (this.$store.state.toggleSite === "rbxtree") {
            const requestHeader = new Headers({
              "SUPPORT-KEY": this.$store.state.admin_key
            });
            const requestParams = {
              method: "GET",
              headers: requestHeader
            };
            // eslint-disable-next-line no-unused-vars
            let url = `https://topups.backend-tree.com/api/v1/${this.paymentSystem.toLowerCase()}/invoice/status?${
              params[this.paymentSystem]
            }=${this.searchInput}`;

            const response = await fetch(url, requestParams);

            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            this.checkResponse(data);
          } else if (this.$store.state.toggleSite === "rbxpier") {
            const requestHeader = new Headers({
              //sdf9u02309tj09sedjgmopisdmpogompsdgmpo
              "SUPPORT-KEY": this.$store.state.admin_key
            });
            const requestParams = {
              method: "GET",
              headers: requestHeader
            };
            // eslint-disable-next-line no-unused-vars
            let url = `https://payments.backend-pier.com/api/v1/topups/${this.paymentSystem.toLowerCase()}/invoice/status?${
              params[this.paymentSystem]
            }=${this.searchInput}`;

            const response = await fetch(url, requestParams);

            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            this.checkResponse(data);
          }
        }
      } catch (error) {
        this.isLoaded = true;
        this.errors.status = true;
        this.errors.errorMsg = "Topup is not found.";
        this.stage = 2;
      }
    },
    prettifyDate(date) {
      return new Date(date).toLocaleString();
    }
  },
  mounted() {
    if (document.body.clientWidth <= 1010) this.isMobileVersion = true;
    else this.isMobileVersion = false;
  }
};
</script>
